import svgLoadingPattern from '!raw-loader!../../../svg/ui_loading_pattern.svg';
export function createGreenPattern() {
    const base64 = btoa(svgLoadingPattern);
    const bg = document.createElement('div');
    bg.style.backgroundImage = `url('data:image/svg+xml;base64,${base64}')`;
    bg.style.backgroundRepeat = 'no-repeat';
    bg.style.backgroundSize = 'cover';
    bg.style.overflow = 'hidden';
    bg.style.position = 'absolute';
    bg.style.width = '100%';
    bg.style.height = '100%';
    return bg;
}
